import { useSwipeable} from 'react-swipeable'
import { AnimatePresence, motion} from 'framer-motion'
import { useSelector, useDispatch } from 'react-redux' 
// css
import './css/slidecomponent.css'
import './css/slide2.css'
//Actions
import { updateGallerieCounter, incrementGallerieCounter, decrementGallerieCounter, triggerGallerieViewer } from '../reducers/ActionsCreator'
//elements
import Swipe from './Swipe'
import GallerieViwer from './GallerieViwer'
//images
import G1 from '../images/static/gallerie/g1.jpg'
import G2 from '../images/static/gallerie/g2.jpg'
import G3 from '../images/static/gallerie/g3.jpg'
import G4 from '../images/static/gallerie/g4.jpg'
import G5 from '../images/static/gallerie/g5.jpg'
import G6 from '../images/static/gallerie/g6.jpg'
import G7 from '../images/static/gallerie/g7.jpg'
import G8 from '../images/static/gallerie/g8.jpg'
import G9 from '../images/static/gallerie/g9.jpg'
import G10 from '../images/static/gallerie/g10.jpg'
import G11 from '../images/static/gallerie/g11.jpg'
import G12 from '../images/static/gallerie/g12.jpg'
import G13 from '../images/static/gallerie/g13.jpg'
import G14 from '../images/static/gallerie/g14.jpg'
import G15 from '../images/static/gallerie/g15.jpg'
import G16 from '../images/static/gallerie/g16.jpg'

const Slide_2 = ({ counter, triggerGallerieView }) => { 
	const dispatch = useDispatch()
	const gallerieReducer = useSelector(state => state.GallerieReducer)
	const SwipeReducer = useSelector(state => state.SwipeReducer.trigger)
	const handlers = useSwipeable({
		onSwipedRight: () => {
			if(gallerieReducer.counter===0) return
				dispatch(decrementGallerieCounter("right"))
		},
		onSwipedLeft: () => {
			if(gallerieReducer.counter===3) return
				dispatch(incrementGallerieCounter("left"))
		}
	})
	return(
		<AnimatePresence>
			{counter === 2 &&
			<motion.div {...handlers}
				key="slide_components_1key0"
				initial={{opacity:0}}
				animate={{opacity:1}}
				transition={{duration:1}}
				exit={{opacity:0}}
				className="slide_components" id="slide_components_2" 
				>
					{SwipeReducer&&<Swipe />}

					{gallerieReducer.viewer&&<GallerieViwer viewer={gallerieReducer.viewer} />}

				<div className="gallerie_head">
					<i className="fas fa-couch"></i>
					<p>Gallerie & showroom</p>
				</div>
				<div className="gallerie_body">
					<AnimatePresence>
						{gallerieReducer.counter===0&&
						<motion.div className="gallerie_card" initial={{opacity:0}} animate={{opacity:1}} transition={{duration:.5}} exit={{opacity:0}}>
							<motion.div className="gallerie_card_item" initila={gallerieReducer.dir==="right"?{x:-10}:{x:10}} animate={{x:0}} >
								<div onClick={() => dispatch(triggerGallerieViewer("g1"))} className="item_content">
									<img src={G1} alt="" />
								</div>
							</motion.div>
							<motion.div className="gallerie_card_item" initila={gallerieReducer.dir==="right"?{x:-10}:{x:10}} animate={{x:0}} >
								<div onClick={() => dispatch(triggerGallerieViewer("g2"))} className="item_content">
									<img src={G2} alt="" />
								</div>
							</motion.div>
							<motion.div className="gallerie_card_item" initila={gallerieReducer.dir==="right"?{x:-10}:{x:10}} animate={{x:0}} >
								<div onClick={() => dispatch(triggerGallerieViewer("g3"))} className="item_content">
									<img src={G3} alt="" />
								</div>
							</motion.div>
							<motion.div className="gallerie_card_item" initila={gallerieReducer.dir==="right"?{x:-10}:{x:10}} animate={{x:0}} >
								<div onClick={() => dispatch(triggerGallerieViewer("g4"))} className="item_content">
									<img src={G4} alt="" />
								</div>
							</motion.div>
						</motion.div>
						}
					</AnimatePresence>

					<AnimatePresence>
						{gallerieReducer.counter===1&&
						<motion.div className="gallerie_card" initial={{opacity:0}} animate={{opacity:1}} transition={{duration:.5}} exit={{opacity:0}}>
							<motion.div className="gallerie_card_item" initila={gallerieReducer.dir==="right"?{x:-10}:{x:10}} animate={{x:0}} >
								<div onClick={() => dispatch(triggerGallerieViewer("g5"))} className="item_content">
									<img src={G5} alt="" />
								</div>
							</motion.div>
							<motion.div className="gallerie_card_item" initila={gallerieReducer.dir==="right"?{x:-10}:{x:10}} animate={{x:0}} >
								<div onClick={() => dispatch(triggerGallerieViewer("g6"))} className="item_content">
									<img src={G6} alt="" />
								</div>
							</motion.div>
							<motion.div className="gallerie_card_item" initila={gallerieReducer.dir==="right"?{x:-10}:{x:10}} animate={{x:0}} >
								<div onClick={() => dispatch(triggerGallerieViewer("g7"))} className="item_content">
									<img src={G7} alt="" />
								</div>
							</motion.div>
							<motion.div className="gallerie_card_item" initila={gallerieReducer.dir==="right"?{x:-10}:{x:10}} animate={{x:0}} >
								<div onClick={() => dispatch(triggerGallerieViewer("g8"))} className="item_content">
									<img src={G8} alt="" />
								</div>
							</motion.div>
						</motion.div>
						}
					</AnimatePresence>

					<AnimatePresence>
						{gallerieReducer.counter===2&&
						<motion.div className="gallerie_card" initial={{opacity:0}} animate={{opacity:1}} transition={{duration:.5}} exit={{opacity:0}}>
							<motion.div className="gallerie_card_item" initila={gallerieReducer.dir==="right"?{x:-10}:{x:10}} animate={{x:0}} >
								<div onClick={() => dispatch(triggerGallerieViewer("92"))} className="item_content">
									<img src={G9} alt="" />
								</div>
							</motion.div>
							<motion.div className="gallerie_card_item" initila={gallerieReducer.dir==="right"?{x:-10}:{x:10}} animate={{x:0}} >
								<div onClick={() => dispatch(triggerGallerieViewer("g10"))} className="item_content">
									<img src={G10} alt="" />
								</div>
							</motion.div>
							<motion.div className="gallerie_card_item" initila={gallerieReducer.dir==="right"?{x:-10}:{x:10}} animate={{x:0}} >
								<div onClick={() => dispatch(triggerGallerieViewer("g11"))} className="item_content">
									<img src={G11} alt="" />
								</div>
							</motion.div>
							<motion.div className="gallerie_card_item" initila={gallerieReducer.dir==="right"?{x:-10}:{x:10}} animate={{x:0}} >
								<div onClick={() => dispatch(triggerGallerieViewer("g12"))} className="item_content">
									<img src={G12} alt="" />
								</div>
							</motion.div>
						</motion.div>
						}
					</AnimatePresence>

					<AnimatePresence>
						{gallerieReducer.counter===3&&
						<motion.div className="gallerie_card" initial={{opacity:0}} animate={{opacity:1}} transition={{duration:.5}} exit={{opacity:0}}>
							<motion.div className="gallerie_card_item" initila={gallerieReducer.dir==="right"?{x:-10}:{x:10}} animate={{x:0}} >
								<div onClick={() => dispatch(triggerGallerieViewer("g13"))}  className="item_content">
									<img src={G13} alt="" />
								</div>
							</motion.div>
							<motion.div className="gallerie_card_item" initila={gallerieReducer.dir==="right"?{x:-10}:{x:10}} animate={{x:0}} >
								<div onClick={() => dispatch(triggerGallerieViewer("g14"))}  className="item_content">
									<img src={G14} alt="" />
								</div>
							</motion.div>
							<motion.div className="gallerie_card_item" initila={gallerieReducer.dir==="right"?{x:-10}:{x:10}} animate={{x:0}} >
								<div onClick={() => dispatch(triggerGallerieViewer("g15"))}  className="item_content">
									<img src={G15} alt="" />
								</div>
							</motion.div>
							<motion.div className="gallerie_card_item" initila={gallerieReducer.dir==="right"?{x:-10}:{x:10}} animate={{x:0}} >
								<div onClick={() => dispatch(triggerGallerieViewer("g16"))}  className="item_content">
									<img src={G16} alt="" />
								</div>
							</motion.div>
						</motion.div>
						}
					</AnimatePresence>

				</div>
				<div className="gallerie_caroucel_buttons_container">
					<button style={gallerieReducer.counter===0?{backgroundColor:"#B8405E"}:{backgroundColor:"#535353"}} onClick={() => dispatch(updateGallerieCounter(0))}></button>
					<button style={gallerieReducer.counter===1?{backgroundColor:"#B8405E"}:{backgroundColor:"#535353"}} onClick={() => dispatch(updateGallerieCounter(1))}></button>
					<button style={gallerieReducer.counter===2?{backgroundColor:"#B8405E"}:{backgroundColor:"#535353"}} onClick={() => dispatch(updateGallerieCounter(2))}></button>
					<button style={gallerieReducer.counter===3?{backgroundColor:"#B8405E"}:{backgroundColor:"#535353"}} onClick={() => dispatch(updateGallerieCounter(3))}></button>
				</div>
			</motion.div>
			}
		</AnimatePresence>
		)
}

export default Slide_2